import { Outlet } from '@remix-run/react'
import { Button } from '#app/components/ui/button'
import { appStoreLink, googlePlayLink } from '#app/utils/misc'
import { AvailableCleaningProviders } from '../available-cleaning-providers'

export default function ProviderRoute() {
	return (
		<div className="mx-auto my-6 rounded-xl py-10 lg:container xs:px-6 sm:px-12 lg:bg-white lg:px-16">
			<div className="mt-6 flex justify-between gap-4 max-lg:flex-col">
				<div className="flex flex-col lg:max-w-3xl">
					<Outlet />
				</div>
				<div className="flex flex-col">
					<AvailableCleaningProviders />
					<div className="mt-10 lg:hidden">
						<div className="text-lg font-semibold leading-8">
							Stáhněte si Izzy do telefonu
						</div>
						<div className="mt-4 flex flex-col gap-4 text-center text-sm font-medium leading-6 text-white">
							<a href={appStoreLink}>
								<Button className="inline-flex w-full gap-2.5">
									<img
										src="/img/app-store-icon.svg"
										alt="app-store"
										width={110.1}
										height={35.88}
									/>
									<div>App Store</div>
								</Button>
							</a>
							<a href={googlePlayLink}>
								<Button className="inline-flex w-full gap-2.5">
									<img
										src="/img/google-play-icon.svg"
										alt="google-play"
										width={110.1}
										height={35.88}
									/>
									<div>Google Play</div>
								</Button>
							</a>
						</div>
					</div>
					<div className="mt-6 hidden py-4 lg:block">
						<div className="text-center text-lg font-bold leading-6 ">
							Stáhněte si Izzy do telefonu
						</div>
						<div className="mt-2.5 flex justify-between px-4">
							<a href={appStoreLink}>
								<img
									src="/img/app-store.svg"
									alt="app-store"
									width={110.1}
									height={35.88}
								/>
							</a>
							<a href={googlePlayLink}>
								<img
									src="/img/google-play.svg"
									alt="google-play"
									width={110.1}
									height={35.88}
								/>
							</a>
						</div>
					</div>
				</div>
			</div>
		</div>
	)
}
